import { ImagePTComponent } from '@/src/components/portableTextComponents/imagePTComponent/ImagePTComponent';
import { LinkPTComponent } from '@/src/components/portableTextComponents/linkPTComponent/LinkPTComponent';
import { TablePTComponent } from '@/src/components/portableTextComponents/tablePTComponent/TablePTComponent';

export const postPortableTextComponents = {
    types: {
        image: ImagePTComponent,
        table: TablePTComponent,
    },
    marks: {
        link: LinkPTComponent,
    },
};

export const captionPortableTextComponents = {
    marks: {
        link: LinkPTComponent,
    },
};
